import React from 'react';
import './Popup.css';

export default function Popup({ title, message, onClose, type = 'info' }) {
  return (
    <div className="popup-backdrop" role="dialog" aria-modal="true">
      <div className={`popup-card popup-${type}`}>
        {title && <h3 className="popup-title">{title}</h3>}
        <div className="popup-body">{message}</div>
        <div className="popup-actions">
          <button className="popup-btn" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
}
